import React from 'react';
import { useSelector, } from 'react-redux'
import { Typography, Grid} from '@mui/material';
import moment from 'moment'
import 'moment/locale/ru';

import PrintKS2Dialog from './PrintKS2Dialog'
export default function KS2ByIdHeader({ formName, idDoc, idProject }) {
  const formTable = useSelector(state => state.formTable[formName] || state.formTable.default)
  const { doc = {} } = formTable
  return <div>
    <PrintKS2Dialog idDoc={idDoc} idProject={idProject} />
    <Grid
      item
      container
    // xs={9}
    >
      <GridProps name='Инвестор:' value={doc.investor + ' ' + doc.investorAdress || ''} />
      <GridProps name='Заказчик(Генподрядчик):' value={doc.customer + ' ' + doc.customerAdress || ''} />
      <GridProps name='Подрядчик (Субподрядчик):' value={doc.contractor + ' ' + doc.contractorAdress || ''} />
      <GridProps name='Стройка:' value={doc.facilityName + '' + doc.facilityAddress} />
      <GridProps name='Объект:' value={doc.projectName} />
      <GridProps name='Договор подряда (контракт):' value={
        <Typography><b>номер: </b>{doc.contractNumber} <b>дата:</b>{doc.contractDateDay + '.' + doc.contractDateMonth + '.' + doc.contractDateYear}</Typography>
      } />
      <GridProps name='Номер документа:' value={doc.ksPrefix + '' + doc.number} />
      <GridProps name='Отчетный период' value={
        <Typography><b>c: </b>{moment(doc.dateStart).format('DD.MM.YYYY')} <b>по: </b>{moment(doc.dateEnd).format('DD.MM.YYYY')}</Typography>
      } />
    </Grid>
  </div>
}

function GridProps({ name = '', value = '', xsStart = 3, xsEnd = 9 }) {
  return <React.Fragment>
    <Grid item xs={xsStart}><Typography><b>{name}</b></Typography></Grid>
    <Grid item xs={xsEnd}>{(typeof value === 'object') ? value : <Typography>{value}</Typography>}</Grid>
  </React.Fragment>
}